import calendarLinkHandler from './handlers';
import { getCLTypes, ICalendarEventsProps } from './types';
import { FC } from 'react';

const CalendarEvents: FC<ICalendarEventsProps> = (props) => {
  return <>{getCLTypes().map(type => calendarLinkHandler(props, type))}</>
}

export default CalendarEvents;